import { EthereumAddress } from '@/utils/currency';

export const EVM_POINTS_CURRENCY_ADDRESS = '0x0000000000000000000000000000000000000000';

export interface CurrencyType {
  address: EthereumAddress;
  chainId: number;
}
